import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface AmendmentNotificationState {
  isAmending: boolean
  hasError: boolean
  errorMessage: string | null
  notificationShown: boolean
}

const initialState: AmendmentNotificationState = {
  isAmending: false,
  hasError: false,
  errorMessage: null,
  notificationShown: false
}

const slice = createSlice({
  name: 'amendmentNotification',
  initialState,
  reducers: {
    // Start amendment process
    startAmendment(state) {
      state.isAmending = true
      state.hasError = false
      state.errorMessage = null
      state.notificationShown = false
    },

    // Amendment succeeded
    amendmentSuccess(state) {
      state.isAmending = false
      state.hasError = false
      state.errorMessage = null
      state.notificationShown = true
    },

    // Amendment failed
    amendmentError(state, action: PayloadAction<string>) {
      state.isAmending = false
      state.hasError = true
      state.errorMessage = action.payload
      state.notificationShown = false
    },

    // Reset amendment state
    resetAmendment(state) {
      state.isAmending = false
      state.hasError = false
      state.errorMessage = null
      state.notificationShown = false
    }
  }
})

export const { startAmendment, amendmentSuccess, amendmentError, resetAmendment } = slice.actions
export default slice.reducer
